import React, { useState } from 'react';
import './Modal.css';

function SimulateRoundModal({ onConfirm, onCancel }) {
  const [password, setPassword] = useState('');
  const [percentage, setPercentage] = useState(50);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password) {
      setError('Admin password is required.');
      return;
    }
    if (percentage < 1 || percentage > 100) {
      setError('Please enter a percentage between 1 and 100.');
      return;
    }
    onConfirm(password, percentage);
  };

  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
      <div className="modal-content">
        <h2>Simulate Round</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="sim-password">Admin Password:</label>
            <input
              type="password"
              id="sim-password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(''); }}
              autoFocus
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="sim-percentage">Percentage of Remaining Anglers to Fish (%):</label>
            <input
              type="number"
              id="sim-percentage"
              min="1"
              max="100"
              value={percentage}
              onChange={(e) => { setPercentage(parseInt(e.target.value) || 50); setError(''); }}
              required
            />
            <small style={{ display: 'block', marginTop: '5px', color: '#666' }}>
              Enter 100 to fish all remaining anglers
            </small>
          </div>
          {error && <p className="modal-message error">{error}</p>}
          <div className="modal-actions">
            <button type="submit" className="btn btn-primary">Simulate</button>
            <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SimulateRoundModal;
